import { useState, useEffect } from 'react';
import { Box, Container, Paper, Grid } from '@mui/material';
import { useForm, FieldValues, Controller, FieldErrors } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';

import CustomButton from '../../../components/Button/button';
import CustomTextField from '../../../components/TextField/textField';
import CustomTypography from '../../../components/Typography/typography';
import styles from '../../../assets/styles/userResetPassWord';
import { userresetpassword } from '../../../redux/slice/authSlice';
import ShowPassword from '../../../components/showPassword/ShowPassword';
import { useSelector } from 'react-redux';
import logo from '../../../assets/images/logo1.png';

const ResetPassword = () => {
  const { id } = useParams();
  const { time } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setpassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState(false);
  const [isRequestExpired, setIsRequestExpired] = useState(false);
  const resetPasswordData = useSelector(
    (state: any) => state.auth.userresetpasswordData
  );

  const userId =
    id &&
    CryptoJS.AES.decrypt(decodeURIComponent(id!), 'dandybooks')
      .toString(CryptoJS.enc.Utf8)
      .replaceAll('"', '');
  const requestTime =
    time &&
    CryptoJS.AES.decrypt(decodeURIComponent(time!), 'dandybooks').toString(
      CryptoJS.enc.Utf8
    );

  const classes = styles();
  const form = useForm({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  });
  const { handleSubmit, control, formState, clearErrors } = form;
  const { errors, isSubmitting } = formState;

  //submit method that calls reset password api
  const onSubmit = (data: FieldValues) => {
    const newData = { ...data, id: userId, requestTime };
    isRequestExpired &&
      toast.error('request time out, please send another request');

    !isRequestExpired && dispatch(userresetpassword(newData));
  };
  const onError = (errors: FieldErrors) => {};

  useEffect(() => {
    !resetPasswordData &&
      setIsRequestExpired(Date.now() - Number(requestTime) > 1800000);

    if (resetPasswordData?._id) {
      setIsRequestExpired(true);
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetPasswordData]);

  return (
    <>
      <Container maxWidth='sm' className={classes.containerRoot}>
        <Box className={classes.Box}>
          <Paper className={classes.headingText} elevation={5}>
            <div className='heading-container'>
              <div>
                <CustomTypography variant='h3'>Reset Password</CustomTypography>
              </div>
              <img alt='logo' src={logo} width={80} className='logo-image' />
            </div>

            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <Grid container className={classes.GridContainer} spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='password'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          type={password ? 'text' : 'password'}
                          label='Password'
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={password}
                          onClick={() => setpassword(!password)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a password',
                      },
                      minLength: {
                        value: 6,
                        message: 'Password must be 6 character',
                      },
                      maxLength: {
                        value: 20,
                        message: 'Password must be less than 20 character',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography variant='body2' color='red' align='justify'>
                    {errors.password?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='confirmPassword'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          label='Confirm password'
                          type={confirmPassword ? 'text' : 'password'}
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={confirmPassword}
                          onClick={() => setconfirmPassword(!confirmPassword)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a Confirm password',
                      },
                      minLength: {
                        value: 6,
                        message: 'confirm password must be 6 character',
                      },
                      maxLength: {
                        value: 20,
                        message:
                          'confirm password must be less than 20 character',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Confirm password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography variant='body2' color='red' align='justify'>
                    {errors.confirmPassword?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <CustomButton
                  sx={{ mt: 2 }}
                  type='submit'
                  fullWidth
                  color='primary'
                  disabled={isSubmitting}
                >
                  Submit{' '}
                </CustomButton>
              </Grid>
            </form>
            <CustomTypography align='right' className={classes.GridContainer}>
              <Link className='customAuthLinkStyle' to='/'>
                <CustomButton variant='text' color='primary' sx={{ mt: 2 }}>
                  Back to signin
                </CustomButton>
              </Link>
            </CustomTypography>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default ResetPassword;
